import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BaseResponse } from "../_types";

export type DeleteIPRestrictionRequest = {
  id: string;
};

async function deleteIPRestriction(
  data: DeleteIPRestrictionRequest
): Promise<BaseResponse<null>> {
  try {
    return (await axiosInstance.delete(`/IPRestriction/Delete?id=${data.id}`)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useDeleteIPRestriction() {
  return useMutation<BaseResponse<null>, Error, DeleteIPRestrictionRequest>(
    (variables) => deleteIPRestriction(variables)
  );
}
